import EA from '../helpers/init';

export default EA.Methods.mobileMenuHandler = ($this) => {
    const hamburger = $this.querySelector('.mobile-menu-btn');
    const mobileMenu = $this.querySelector('.mobile-nav-menu');

    if(!hamburger || !mobileMenu) return;

    const closeAllSubMenus = (scopeEl = mobileMenu) => {
        scopeEl.querySelectorAll('.mobile-sub-menu.open').forEach((subMenu) => {
            subMenu.parentElement.querySelector('.mobile-nav-menu-link').classList.remove('open');
            subMenu.classList.remove('open');
            subMenu.inert = true;
        });
    };

    hamburger.addEventListener('click', () => {
        if (hamburger.getAttribute('aria-expanded') === 'true') {
            hamburger.setAttribute('aria-expanded', 'false');
            document.body.classList.remove('no-scroll');
            closeAllSubMenus();
        } else {
            hamburger.setAttribute('aria-expanded', 'true');
            document.body.classList.add('no-scroll');
        }

        hamburger.classList.toggle('is-active', hamburger.getAttribute('aria-expanded') === 'true');
        mobileMenu.classList.toggle('open', hamburger.getAttribute('aria-expanded') === 'true');
    });

    mobileMenu.addEventListener('click', (e) => {
        const btn = e.target.closest('button.mobile-nav-menu-link');

        if(!btn) return;

        const wrapperItem = btn.closest('.mobile-nav-menu-item');
        const subMenu = wrapperItem?.querySelector('.mobile-sub-menu');

        if(!subMenu) return;

        e.preventDefault();

        const wrapperList = wrapperItem.parentElement;

        wrapperList?.querySelectorAll(':scope > .mobile-nav-menu-item > .mobile-sub-menu.open').forEach((el) => {
            if(el !== subMenu) {
                el.parentElement.querySelector('.mobile-nav-menu-link').classList.remove('open');
                el.classList.remove('open');
                el.inert = true;
            }
        });

        
        btn.classList.toggle('open');
        subMenu.classList.toggle('open');
        subMenu.inert = !subMenu.classList.contains('open');
        if(!subMenu.classList.contains('open')) {
            closeAllSubMenus(subMenu);
        };
    });
};
